// import UserComponent from "../MVPComponents/UserComponent";
import ChangePasswordComponent from "../NonMVPComponents/ChangePasswordComponent";
const User = () => {
  return (
    <div>
      {/* <UserComponent /> */}
      <ChangePasswordComponent />
    </div>
  );
};

export default User;
